import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Moment from 'moment';
import { extendMoment } from 'moment-range';
var moment = extendMoment(Moment);
export default {
  name: 'DateRangePicker',
  props: {
    value: {
      required: true,
      type: [Array, Object]
    },
    startDate: {
      type: String,
      required: true,
      validator: function validator(value) {
        return moment(value).isValid();
      }
    },
    endDate: {
      type: String,
      required: true,
      validator: function validator(value) {
        return moment(value).isValid();
      }
    },
    firstDayOfWeek: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      lastClickedDate: this.value.to
    };
  },
  computed: {
    weekDays: function weekDays() {
      moment.updateLocale(this.me.settings.appLanguage || 'en', {
        week: {
          dow: this.firstDayOfWeek
        }
      });
      return moment.weekdays(true).map(function (day) {
        return day[0];
      });
    },
    internalStartDate: function internalStartDate() {
      if (this.startDate) return moment(this.startDate);
      return moment(this.me.account.created_date).subtract(2, 'year');
    },
    internalEndDate: function internalEndDate() {
      if (this.endDate) return moment(this.endDate);
      return moment().add(3, 'months');
    },
    visibleMonths: function visibleMonths() {
      var _this = this;

      var dateStart = this.internalStartDate.startOf('month');
      var dateEnd = this.internalEndDate.endOf('month');
      var monthsRange = moment.range(dateStart, dateEnd);
      return Array.from(monthsRange.by('months', {
        step: 1
      })).map(function (month) {
        var monthKey = month.format('YYYY_MM');
        var monthStart = month.clone().startOf('month');
        var monthEnd = month.clone().endOf('month').endOf('week');
        var monthRange = moment.range(monthStart, monthEnd);
        var weeks = Array.from(monthRange.by('weeks', {
          step: 1
        })).map(function (week) {
          var monthStart = week.startOf('week');
          var monthEnd = week.clone().endOf('week');
          var weekRange = moment.range(monthStart, monthEnd);
          return Array.from(weekRange.by('days', {
            step: 1
          })).map(function (day) {
            return {
              number: day.format('D'),
              month: day.format('MMMM'),
              formatted_date: day.format('YYYY-MM-DD')
            };
          });
        });
        return {
          name: month.format('MMMM'),
          key: monthKey,
          label: month.format('MMM YYYY'),
          startingDay: month.day() - _this.firstDayOfWeek,
          weeks: weeks
        };
      });
    },
    today: function today() {
      return moment().format('YYYY-MM-DD');
    },
    rangeStart: function rangeStart() {
      if (this.value.from > this.value.to) return this.value.to;
      return this.value.from;
    },
    rangeEnd: function rangeEnd() {
      if (this.value.from > this.value.to) return this.value.from;
      return this.value.to;
    }
  },
  methods: {
    updateRange: function updateRange(day) {
      var from = day.formatted_date;
      var to = day.formatted_date;

      if (this.lastClickedDate) {
        if (day.formatted_date > this.lastClickedDate) {
          from = this.lastClickedDate;
        } else {
          to = this.lastClickedDate;
        }
      }

      this.$emit('input', {
        from: from,
        to: to
      });
      this.updateLastClickedDate(day.formatted_date);
    },
    updateLastClickedDate: function updateLastClickedDate(date) {
      this.lastClickedDate = date;
    },
    bringIntoViewDate: function bringIntoViewDate(formattedDate) {
      var behaviour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'smooth';

      if (this.$refs[formattedDate]) {
        this.$refs[formattedDate][0].scrollIntoView({
          block: 'center',
          behavior: behaviour
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      var focusDate = _this2.rangeEnd ? moment(_this2.rangeEnd) : moment();

      _this2.bringIntoViewDate(focusDate.format('YYYY-MM-DD'), 'auto');
    });
  }
};